export default __webpack_public_path__ + "static/media/output.01c6a167.webm";